import React, { useState } from "react";
import { Box, Grid, Divider, Card, CardContent } from "@mui/material";
import { useNavigate, Link } from "react-router-dom";
import TAGlogo from "assets/images/TAGlogo.svg";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { LoginForm } from "components/Forms";

const Alert = React.forwardRef(function Alert(props, ref) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function LoginPage() {
  const navigate = useNavigate();
  const [openAlert, setOpenAlert] = useState(false);
  const responseHandler = (response) => {
    if (response) {
      navigate("/organization");
    }
    setOpenAlert(!response);
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };
  return (
    <div className="b-login-container">
      <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="error"
          className="b-login-container__alert"
        >
          Email or password is wrong!
        </Alert>
      </Snackbar>
      <Box className="b-login-container__box">
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <img
              className="b-login-container__logo"
              src={TAGlogo}
              alt="Error in loading"
            />
          </Grid>
        </Grid>
      </Box>
      <Divider />
      <div className="b-login-container__body">
        <Grid
          container
          spacing={2}
          direction="column"
          alignItems="center"
          justify="center"
          className="b-login-container__alignment"
        >
          <Grid className="b-login-container__card" item xs={12}>
            <Card className="b-login-container__cardHead">
              <CardContent className="b-login-container__content">
                <div className="default-card-header-padding">
                  <h2>Log in to TAG Admin</h2>
                </div>
              </CardContent>
              <CardContent className="remove b-login-container__cardContent">
                <LoginForm responseFunc={responseHandler} />
              </CardContent>
              <div className="b-login-container__forgotPassText">
                <Link
                  className=" dafault-font-famil b-login-container__link"
                  to="/forgotpassword"
                >
                  Forgot username or password?
                </Link>
              </div>
            </Card>
            <Grid item xs={12} />
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default LoginPage;
